import { TEST_IDS } from "@/constants/testIds";

const ComingSoon = () => {
    return (
        <section
            id="coming-soon"
            data-testid={TEST_IDS.comingSoonSection}
            className="relative overflow-hidden bg-navy text-white py-28 md:py-36"
        >
            {/* Animated concentric rings */}
            <div
                className="absolute inset-0 flex items-center justify-center pointer-events-none"
                aria-hidden="true"
            >
                <div className="relative w-[600px] h-[600px] md:w-[900px] md:h-[900px] opacity-40">
                    <span className="absolute inset-0 rounded-full border border-white/15 animate-ring-slow" />
                    <span
                        className="absolute inset-0 rounded-full border border-white/15 animate-ring-slow"
                        style={{ animationDelay: "1s" }}
                    />
                    <span
                        className="absolute inset-0 rounded-full border border-white/10 animate-ring-slow"
                        style={{ animationDelay: "2s" }}
                    />
                    <span
                        className="absolute inset-0 rounded-full border border-white/10 animate-ring-slow"
                        style={{ animationDelay: "3s" }}
                    />
                </div>
            </div>

            {/* Faint dot grid */}
            <div
                className="absolute inset-0 opacity-[0.07] pointer-events-none"
                style={{
                    backgroundImage:
                        "radial-gradient(circle at 1px 1px, #ffffff 1px, transparent 0)",
                    backgroundSize: "32px 32px",
                }}
                aria-hidden="true"
            />

            <div className="relative max-w-5xl mx-auto px-6 md:px-10 lg:px-14 text-center">
                <p className="text-[11px] tracking-[0.32em] uppercase text-white/60 font-medium mb-7">
                    In Development
                </p>

                <h2
                    data-testid={TEST_IDS.comingSoonHeading}
                    className="font-serif text-5xl md:text-7xl lg:text-[88px] leading-[1.02] tracking-tight"
                >
                    More is <span className="italic text-white/90">coming.</span>
                </h2>

                <p className="mt-8 max-w-2xl mx-auto text-lg md:text-xl text-white/80 leading-relaxed font-light">
                    Southern African Traders Ltd is continuously developing new platforms
                    that promote dialogue, education, cultural exchange, and integration.
                </p>

                <p className="mt-6 text-sm md:text-base tracking-[0.08em] text-white/55">
                    New ideas. New experiences. New ways to connect.
                </p>

                {/* Pulsing dots indicator */}
                <div className="mt-12 inline-flex items-center gap-2">
                    {[0, 200, 400].map((d) => (
                        <span
                            key={d}
                            className="w-1.5 h-1.5 rounded-full bg-white/60"
                            style={{
                                animation: "drift 1.6s ease-in-out infinite",
                                animationDelay: `${d}ms`,
                            }}
                        />
                    ))}
                    <span className="ml-3 text-[10px] tracking-[0.3em] uppercase text-white/50">
                        Building Quietly
                    </span>
                </div>
            </div>
        </section>
    );
};

export default ComingSoon;
